import React, { useState, useEffect, useRef } from 'react';
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { FaStar } from "react-icons/fa";
import "./Testimonial.css";
import user3 from "../../../Assets/Users/12225935.png";

const Testimonial = () => {
  const testimonials = [
    {
      id: 1,
      name: "Sarah Johnson",
      role: "Verified Buyer",
      content: "The quality of their clothing is exceptional. I've been a loyal customer for years and have never been disappointed. Their attention to detail and customer service are outstanding.",
      rating: 4,
      image: user3
    },
    {
      id: 2,
      name: "Michael Chen",
      role: "Verified Buyer",
      content: "UOMO's collection offers the perfect blend of style and comfort. The fit is always perfect, and their seasonal collections are always on point. Highly recommended!",
      rating: 3,
      image: user3
    },
    {
      id: 3,
      name: "Emma Davis",
      role: "Fashion Blogger",
      content: "As someone who's always looking for quality fashion, UOMO never disappoints. Their pieces are timeless and the quality is worth every penny.",
      rating: 4,
      image: user3
    },
    {
      id: 4,
      name: "David Wilson",
      role: "Verified Buyer",
      content: "The shopping experience was seamless from start to finish. The clothes fit perfectly and the quality exceeds expectations. Will definitely be shopping here again!",
      rating: 5,
      image: user3
    }
  ];

  // Duplicate testimonials for looping effect
  const duplicatedTestimonials = [testimonials[testimonials.length - 1], ...testimonials, testimonials[0]];

  const [currentIndex, setCurrentIndex] = useState(1); // Start at the first original testimonial
  const [isAnimating, setIsAnimating] = useState(false);
  const wrapperRef = useRef(null);
  const intervalRef = useRef(null);

  const resetInterval = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      handleNext();
    }, 5000);
  };

  useEffect(() => {
    resetInterval();
    return () => clearInterval(intervalRef.current);
  }, []);

  const handleSlideChange = (newIndex) => {
    if (isAnimating) return;
    
    setIsAnimating(true);
    const totalSlides = duplicatedTestimonials.length;
    
    if (newIndex < 0 || newIndex >= totalSlides) {
      // Remove transition for instant jump
      if (wrapperRef.current) {
        wrapperRef.current.style.transition = 'none';
        
        // Set the new index immediately
        const finalIndex = newIndex < 0 ? totalSlides - 2 : 1;
        setCurrentIndex(finalIndex);
        
        wrapperRef.current.style.transform = `translateX(-${finalIndex * 100}%)`;
        
        // Force a reflow
        const reflow = wrapperRef.current.getBoundingClientRect();
        
        // Restore transition
        requestAnimationFrame(() => {
          if (wrapperRef.current) {
            wrapperRef.current.style.transition = 'transform 0.5s ease-in-out';
          }
        });
      }
    } else {
      // Normal slide transition
      if (wrapperRef.current) {
        wrapperRef.current.style.transition = 'transform 0.5s ease-in-out';
        wrapperRef.current.style.transform = `translateX(-${newIndex * 100}%)`;
      }
      setCurrentIndex(newIndex);
    }

    setTimeout(() => {
      setIsAnimating(false);
    }, 500);
  };

  const handlePrev = () => {
    handleSlideChange(currentIndex - 1);
    resetInterval();
  };

  const handleNext = () => {
    handleSlideChange(currentIndex + 1);
    resetInterval();
  };

  const handleDotClick = (index) => {
    handleSlideChange(index + 1); // Adjust for duplicated slides
    resetInterval();
  };

  return (
    <div className="testimonial">
      <h2>What Our Customers Say</h2>
      <div className="testimonialContainer">
        <div ref={wrapperRef} className="testimonialWrapper">
          {duplicatedTestimonials.map((testimonial, index) => (
            <div key={index} className="testimonialSlide">
              <div className="testimonialContent">
                <div className="testimonialProfileImage">
                  <img 
                    src={testimonial.image} 
                    alt={testimonial.name}
                    onError={(e) => {
                      e.target.src = "/api/placeholder/100/100";
                    }}
                  />
                </div>
                <div className="testimonialStars">
                  {[...Array(5)].map((_, i) => (
                    <FaStar 
                      key={i} 
                      className={i < testimonial.rating ? 'filled' : 'unfilled'} 
                    />
                  ))}
                </div>
                <p className="testimonialText">{testimonial.content}</p>
                <div className="testimonialAuthor">
                  <h4 className="testimonialName">{testimonial.name}</h4>
                  <p className="testimonialRole">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        <button 
          onClick={handlePrev} 
          className="testimonialNav testimonialPrev"
          aria-label="Previous testimonial"
        >
          <IoIosArrowBack />
        </button>
        <button 
          onClick={handleNext} 
          className="testimonialNav testimonialNext"
          aria-label="Next testimonial"
        >
          <IoIosArrowForward />
        </button>
        <div className="testimonialDots">
          {testimonials.map((_, index) => (
            <button
              key={index}
              className={`testimonialDot ${currentIndex === index + 1 ? 'active' : ''}`}
              onClick={() => handleDotClick(index)}
              aria-label={`Go to testimonial ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Testimonial;